import { BaseApiServiceImpl } from "./BaseApiServiceImpl";

export interface PaymentCollectionRequest {
  externalReferenceID?: string;
  customerName: string;
  narration: string;
  currency: string;
  amount: number;
  msisdn: string;
  network: string;
}

export interface PaymentCollectionResponse {
  success: boolean;
  message: string;
  reference: string;
  status: string;
}

export interface TransactionStatus {
  success: boolean;
  reference: string;
  status: string;
  amount: number;
  currency: string;
  msisdn: string;
  network: string;
  customerName: string;
  datetime: string;
}

export interface AccountLookup {
  success: boolean;
  msisdn: string;
  network: string;
  accountName: string;
  status: string;
}

export interface WalletBalance {
  success: boolean;
  availableBalance: number;
  currency: string;
}

/**
 * Unified Payment Service for Apollos gateway.
 * All payment operations go through /api/v1/payments/* endpoints.
 */
export class PaymentService {
  private static baseUrl = "/api/v1/payments";

  static async initiateCollection(
    request: PaymentCollectionRequest
  ): Promise<PaymentCollectionResponse> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/collection`)
      .postRequestWithJsonResponse(request);
    return response?.data ?? response;
  }

  static async checkTransactionStatus(
    reference: string
  ): Promise<TransactionStatus> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/status/${reference}`)
      .getRequestWithJsonResponse({});
    return response?.data ?? response;
  }

  static async lookupAccount(
    msisdn: string,
    network: string
  ): Promise<AccountLookup> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/lookup`).getRequestWithJsonResponse({
      msisdn,
      network,
    });
    return response?.data ?? response;
  }

  static async getPaymentByReference(reference: string): Promise<any> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/transaction/${reference}`)
      .getRequestWithJsonResponse({});
    return response?.data ?? response;
  }

  static async getWalletBalance(): Promise<WalletBalance> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/wallet-balance`)
      .getRequestWithJsonResponse({});
    return response?.data ?? response;
  }

  static async syncPendingPayments(): Promise<number> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/sync`)
      .postRequestWithJsonResponse({});
    return response?.data ?? 0;
  }
}

/**
 * @deprecated Use PaymentService instead. This alias is kept for backward compatibility.
 */
export const KaCyberPayService = PaymentService;
